module.exports = function isBoardmember(ps, user) {
    if (ps.boardmembers) {
        const boardmembers = ps.boardmembers.filter((e) => e === user._id);
        if (boardmembers.length > 0) {
            return true;
        }
    }
    if (ps.subprocesses) {
        for (let i = 0; i < ps.subprocesses.length; i++) {
            const process = ps.subprocesses[i];
            const boardmembers = process.boardmembers.filter((e) => e === user._id);
            process.courses.forEach(curso => {
                if (curso && curso.banca) {
                    let a = curso.banca.filter(e=>e === user._id)
                    if (a.length > 0) boardmembers.push(process)
                }
            });
            if (boardmembers.length > 0) {
                return true;
            }
        }
    }
    if (user.is_admin) return true
    return false;
}